import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';

import {Icon} from 'front-onceforall-core';

import {pathHelpContentFile} from '../../../../utils/path';

const COLLECTION_DOC = `${pathHelpContentFile}fr/FR_MOD_MAND_COLL/Mandat%20de%20Collecte.pdf`;
const BROADCAST_DOC = `${pathHelpContentFile}fr/FR_MOD_MAND_DIFF/Mandat%20de%20Diffusion.pdf`;

function Message({isCollectionMandate}) {
  const email = I18n.t('mandate.list.message.email');

  const docPath = isCollectionMandate ? COLLECTION_DOC : BROADCAST_DOC;

  const getFirstPart = () => (isCollectionMandate ? (
    <Translate
      value="mandate.list.message.firstPart.collection"
      tag="div"
    />
  ) : (<>
    <Translate
      value="mandate.list.message.firstPart.broadcast.part1"
      tag="div"
    />
    <Translate
      value="mandate.list.message.firstPart.broadcast.part2"
      tag="div"
      className='my-3'
    />
  </>));

  return (
    <div
      className="box info flex-container p-4 mb-5"
      data-id="info-box"
    >
      <div style={{flexShrink: 0}}>
        <Icon
          icon="info"
          size={20}
        />
      </div>
      <div>
        {getFirstPart()}
        <div>
          <Translate value="mandate.list.message.secondPart"/>
          <a href={docPath}>
            <Translate value="mandate.list.message.link"/>
          </a>
          <Translate value="mandate.list.message.thirdPart"/>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
      </div>
    </div>
  );
}

Message.propTypes = {
  isCollectionMandate: PropTypes.bool.isRequired
};

export default Message;
